// src/utils/axios.js
import axios from "axios";
import { getToken } from "../context/AuthProvider"; // Ajustá si tu estructura es distinta

const API_BASE = `${window.location.origin}/api`;

const instance = axios.create({
  baseURL: API_BASE,
});

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
